<template>
	<main class="main-wrapper flex-grow-1 bg-documentGray">
		<div class="d-flex align-items-center ">
						<div class="t-headline13 dildar t-color-headlineBlack pda-14 t-center font-m flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center">
										<div class="font-m">{{this.$t('995')}}</div>
						</div>
		</div>

		<div class="divider"></div>
		<!-- subtabs -->
	<TopAppBarExamListTab></TopAppBarExamListTab>
		<div class="container" :class="!isNoData ? 'pdt-30': ''" >
			<NoData :msgData="{msg1:'3096',msg2:'3097'}"  v-if="isNoData" ></NoData>
						<!-- <div class="mgb-24"><img src="images/banner.svg" alt=""></div> -->
				<div class="mdc-card  mgb-50 pdt-8 pdb-8 " v-else>
					<div class="pdt-24 pdb-24 pdl-24 pdr-24 d-flex " :class="index+1 == listData.length ? '' : 'my-test-list'" v-for="(item, index) in listData" :key="index">
									<!-- <img src="images/ic_account.svg" alt="" class="w-40 h-40 mgr-16"> -->
									<div class="flex-grow-1 cursor-pointer"  @click="moveResult(item.examineeId)" @keypress="moveResult(item.examineeId)" tabindex="0">
													<div class="t-body1 font-r t-color-botyGrayA l-spacing48">
																	{{item.name}}
													</div>
													<div class="pdt-4 t-body6 font-r t-color-bodyGrayA l-spacing45 t-line-h-21">
															{{item.category.text}}
														{{item.category.child ? ' > ' + item.category.child.text : ''}}</div>

													<div class="d-flex align-items-center justify-content-between">
																	<div class="pdt-4 t-body6 font-r t-color-bodyGrayA l-spacing45 t-line-h-22" v-if="item.progression.value === 'SUBMITTED'">
																		{{$t('538')}}
																	</div>
																<div class="pdt-4 t-body6 font-r t-color-bodyBlueGray l-spacing45 t-line-h-22" v-else-if="item.progression.value === 'CHECK_SCORE'">
																		{{$t('537')}}
																	</div>
																	<div class="pdt-4 t-body6 font-r t-color-bodyGrayA l-spacing45 t-line-h-22" v-else-if="item.progression.value === 'PERIOD_EXPIRED'">
																		{{$t('539')}}
																	</div>
																	<div class="pdt-4 t-body6 font-r t-color-bodyGrayA l-spacing45 t-line-h-22" v-else-if="item.progression.value === 'NOT_TESTED'">
																		{{$t('540')}}
																	</div>
																	<button class="mdc-icon-button content-trigger mgt--16 mgr--12 mgb--12" tabindex="0" @click.stop="initPointStatus(index)" @keypress.stop="initPointStatus(index)" v-if="item.progression.value === 'CHECK_SCORE'">
																		<i class="material-icons t-headline12 t-color-bodyGrayA">{{item.pointViewStatus ? 'expand_less' : 'expand_more'}}</i></button>
													</div>
													<component :is="`result-graph`"
															v-if="item.pointViewStatus"
															:examineeId="item.examineeId"
															:paperId="item.paperId"
											></component>
									</div>
							</div>
						<infinite-loading @infinite="fetchData" spinner="spiral">
										<div slot="no-more" class="t-center pdt-16 pdb-16"></div>
										<div slot="no-results" class="t-center pdt-16 pdb-16"></div>
						</infinite-loading>
				</div>
		</div>
	</main>
</template>

<script>
/**
 * 단독 시험 결과 리스트 컴포넌트(independent exam result list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import examApi from '@/api/examApi.js'
import {MDCRipple} from '@material/ripple'
import NoData from '../../common/NoData.vue'
import InfiniteLoading from 'vue-infinite-loading'
import TopAppBarExamListTab from "../../TopAppBarExamListTab.vue";
export default {
	name: 'examMy',
	components: {
		NoData, InfiniteLoading,
		'result-graph': () => import('./ResultGraph.vue'),
		TopAppBarExamListTab
	},
	
	data() {
		return {
			isNoData: false,
			listData: [],
			currentPage: 1,
			totalPages: 1
		}
	},
	
	mounted() {
	},

	updated() {
		const ripples = [].map.call(document.querySelectorAll('.ripple-item'), function(el) {
			let ripple = new MDCRipple.attachTo(el)
			return ripple
		})
	},

	methods: {
	   
		// 목록 데이터 호출(get exam list data)
		fetchData($state) {
			let responseData = null
			let params = this.setParams()
			
			if (this.totalPages >= this.currentPage) {
				examApi.independentExamineeExamList(params).then((response) => {
					let responseData = response.data.data

					_.map(responseData.content, (o, idx) => {
						o.pointViewStatus = false
					})
					
					this.listData = this.listData.concat(responseData.content)
					
					this.currentPage++
					this.totalPages = responseData.totalPages
					
					if (responseData.content.length) {
						$state.loaded()
					}else {
						$state.complete()
					}

					if (!this.listData.length) {
						this.isNoData = true
					}
					
				})

			}else {
				$state.complete()
			}
		},


		// 파라미터 설정(set parameter)
		setParams() {
			const params = {
				application: true,
				page: this.currentPage,
				size: 10,
				sort: 'id,desc'
			}
			return params
		},

		// 시험결과 노출 상태 설정(toggle exam result graph)
		initPointStatus(index) {
			_.map(this.listData, (o, idx) => {
				idx === index && o.pointViewStatus === false ? o.pointViewStatus = true : o.pointViewStatus = false
			})
		},


		// 결과 상세로 이동(move result view)
		moveResult(examineeId){
			this.$router.push({
				name: 'IndependentExamResultView',
				params: {examineeId: examineeId},
				query: this.$route.query
			})
			
		}
	}
}
</script>
<style scoped>
.t-color-bodyGrayB {
	color: #818181 !important; 
}
</style>